/**
 * Helper universal para extrair IDs únicos de diferentes fontes de dados.
 */
const toUniqueArray = (values) => {
  return Array.from(
    new Set(
      (values || [])
        .filter(v => v !== null && v !== undefined && v !== '')
        .map(v => String(v))
    )
  );
};

const collect = (sources, keys) => {
  const result = [];
  const sourceList = Array.isArray(sources) ? sources : [sources];
  const keyList = Array.isArray(keys) ? keys : [keys];

  sourceList.forEach(item => {
    if (!item || typeof item !== 'object') return;
    keyList.forEach(key => {
      const value = item[key];
      if (value !== undefined && value !== null && value !== '') {
        result.push(value);
      }
    });
  });
  return result;
};

export const calculateAvailableIds = (input) => {
  let allRows = [];

  if (Array.isArray(input)) {
    allRows = input;
  } else if (input && typeof input === 'object') {

    const internalArrays = Object.keys(input)
      .filter(key => Array.isArray(input[key]))
      .map(key => input[key]);

    allRows = internalArrays.flat();
  }

  const schema = {
    modalidade: ['modalidade', 'idModalidade', 'modality_id'],
    nivelEnsino: ['nivelensino', 'idNivelDeEnsino', 'education_level_id'],
    processo: ['processo', 'idProcesso', 'process_id'],
    curso: ['curso', 'idCurso', 'course_id'],
    unidade: ['unidade', 'idUnidade', 'unit_id'],
    etapa: ['etapa', 'step', 'steps', 'idEtapa', 'step_id', 'nome_etapa'],
    localOferta: ['idLocalOferta']
  };

  const availableIds = {};

  Object.keys(schema).forEach(targetKey => {
    const foundValues = collect(allRows, schema[targetKey]);
    const uniqueValues = toUniqueArray(foundValues);

    if (uniqueValues.length > 0) {
      availableIds[targetKey] = uniqueValues;
    }
  });

  return availableIds;
};
